import React, {
  Dispatch,
  FormEvent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import classNames from "classnames";

import scrollToElement from "utils/browser/scrollToElement";
import { DateProps } from "utils/dateUtils";

import DaySelect from "components/UserProfile/EditProfile/DaySelect";
import MonthSelect from "components/UserProfile/EditProfile/MonthSelect";
import YearSelect, {
  ArrayType,
} from "components/UserProfile/EditProfile/YearSelect";

type DateSelectorsProps = {
  countryCode?: string;
  errorMessage?: string | undefined;
  handleSetDob: Dispatch<SetStateAction<DateProps>>;
  id: string;
  label: string;
  savedDate: DateProps;
  state?: string;
  yearsArrayType?: ArrayType;
};

const DateSelectors: React.FC<DateSelectorsProps> = ({
  countryCode,
  errorMessage,
  handleSetDob,
  id,
  label,
  savedDate,
  state,
  yearsArrayType,
}) => {
  const [daysInSelectedMonth, setDaysInSelectedMonth] = useState(31);

  useEffect(() => {
    if (errorMessage) {
      scrollToElement(`#${id}`);
    }
  }, [errorMessage, id]);

  return (
    <div className="pb-sm">
      <label
        htmlFor={id}
        className={classNames("fs-block form__field font-bold text-xs", {
          "text-error": errorMessage,
        })}
      >
        {label}
      </label>

      <div className="row fs-exclude" id={id}>
        <div className="col-2 p-xs">
          <MonthSelect
            defaultValue={savedDate.month}
            id={id}
            onChange={(e: FormEvent<HTMLInputElement>) => {
              const daysInMonth = new Date(
                savedDate.year,
                Number(e.currentTarget.value),
                0,
              ).getDate();

              setDaysInSelectedMonth(daysInMonth);

              handleSetDob({
                ...savedDate,
                day: daysInMonth < savedDate.day ? 0 : savedDate.day,
                month: Number(e.currentTarget.value),
              });
            }}
          />
        </div>

        <div className="col-2 p-xs">
          <DaySelect
            daysInSelectedMonth={daysInSelectedMonth}
            defaultValue={savedDate.day}
            id={id}
            onChange={(e) =>
              handleSetDob({
                ...savedDate,
                day: Number(e.currentTarget.value),
              })
            }
          />
        </div>

        <div className="col-2 p-xs">
          <YearSelect
            arrayType={yearsArrayType}
            countryCode={countryCode}
            defaultValue={savedDate.year}
            id={id}
            onChange={(e) =>
              handleSetDob({
                ...savedDate,
                year: Number(e.currentTarget.value),
              })
            }
            selectedDay={savedDate.day}
            selectedMonth={savedDate.month}
            state={state}
          />
        </div>

        {errorMessage && (
          <div className="text-xs text-error pt-xs pl-xs">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

export default DateSelectors;
